import request from '@/api/request';
const defaultRequest = request();

export function sendNotification (data) {
  return defaultRequest({
    url: '/notification/topic',
    method: 'post',
    data
  });
}

export function getNotifications () {
  return defaultRequest({
    url: '/notification/news',
    method: 'get'
  });
}

const newDefaultRequest = request('https://api.motrak.vn/api/v2');

export function sendNotificationToUser (data) {
  return newDefaultRequest({
    url: '/dealer/notification/user',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/notification.js